import { render, staticRenderFns } from "./ParticipantDetailsFundraisings.vue?vue&type=template&id=7988577e"
import script from "./ParticipantDetailsFundraisings.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailsFundraisings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports